import Navigation from '../../components/shared/Navigation';
import Footer from '../../components/shared/Footer';
import HeroSection from '../../components/user/HeroSection';
import AboutSection from '../../components/user/AboutSection';
import SkillsSection from '../../components/user/SkillsSection';
import ProjectsSection from '../../components/user/ProjectsSection';
import BlogSection from '../../components/user/BlogSection';
import StatsSection from '../../components/user/StatsSection';
import ContactSection from '../../components/user/ContactSection';

export default function UserPage() {
  return (
    <div className="min-h-screen bg-dark">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <SkillsSection />
        <ProjectsSection />
        <BlogSection />
        <StatsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
